import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

type Props = {
    openLoader: boolean;
    message?: string;
};

const Loader = ({ openLoader, message }: Props) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}
            open={openLoader}
        >
            <CircularProgress color="inherit" />
            <Typography variant="subtitle1" align="center" marginTop={'20px'} fontWeight={'bold'}>
                {message}
            </Typography>
        </Backdrop>
    );
};

export default Loader;
